// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonGoogle_tfqv9 {
    background-color: transparent;
    color: var(--black-color);
    font-size: 16px;
    font-weight: 400;
    border: 1px solid var(--d9-background);
    border-radius: 12px;
    cursor: pointer;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 8px;
    height: 48px;
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/DashboardLogin/LoginButton/LoginButton.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,QAAQ;IACR,YAAY;EACd","sourcesContent":[".buttonGoogle {\n    background-color: transparent;\n    color: var(--black-color);\n    font-size: 16px;\n    font-weight: 400;\n    border: 1px solid var(--d9-background);\n    border-radius: 12px;\n    cursor: pointer;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    gap: 8px;\n    height: 48px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonGoogle": `buttonGoogle_tfqv9`
};
export default ___CSS_LOADER_EXPORT___;
